import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { call } from "../../assets/img";

import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { edit_icon } from "../../assets/img";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";
import { Toast } from "../../Component/Toast";

const ClientList = () => {

  const { kv, set } = useStoreKv();
  const ClientList = kv.clientList || [];
  const REPORT_SCROLL_KEY = "reportScrollPosition";
  const CLIENT_LIST_PAGE_KEY = "clientListCurrentPage";
  const navigate = useNavigate();
  const location = useLocation();
  const scrollRef = useRef(null);
  const navigationType = useNavigationType();

  useEffect(() => {
    const savedPosition = sessionStorage.getItem(REPORT_SCROLL_KEY);

//     console.log("Navigation Type:", navigationType, "Saved Position:", savedPosition);

    if (scrollRef.current) {
      if (navigationType === 'POP' && savedPosition) {
        // Restore position on back/forward navigation
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTop = Number(savedPosition);
          }
        }, 0);
      } else {
        // Scroll to top on fresh entry (PUSH or REPLACE)
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
          }
          // Also clear the saved position for next time if it wasn't a POP
          sessionStorage.setItem(REPORT_SCROLL_KEY, 0);
        }, 0);
      }
    }
  }, [location, navigationType]);

  useEffect(() => {
    const content = scrollRef.current;
    if (content) {
      content.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (content) {
        content.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);


  const handleScroll = () => {
    const position = scrollRef.current ? scrollRef.current.scrollTop : 0;
    sessionStorage.setItem(REPORT_SCROLL_KEY, position);
  };


  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("isReload", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  const [errors, setErrors] = useState({});
  const [mobile, setMobile] = useState("");
  const [searchData, setSearchData] = useState('')
  const [page, setPage] = useState(() => {
    const savedPage = Number(sessionStorage.getItem(CLIENT_LIST_PAGE_KEY));
    return Number.isInteger(savedPage) && savedPage > 0 ? savedPage : 1;
  });
  const [pagecount, setPagecount] = useState();
  const [totalUser, setTotalUser] = useState(0);
  const [totalUser1, setTotalUser1] = useState(0);
  const [loading, setLoading] = useState(false);
  const [browsHeader, setBrowsHeader] = useState(true);

  const [owners, setOwners] = useState(ClientList);
  const [formData, setFormData] = useState({
    client: "",
    mobile: "",
    Password: "",
    ClientID: "",
  });


  const getList = async (page = 1, filters = [], currentRequestId) => {

    if (!kv.clientList || kv.clientList.length === 0) {
      setLoading(true);
    }

    try {
      const query = filters.length ? `&${filters.join("&")}` : "";
      const res = await get(`${URLS.CLIENT}?page=${page}${query}`);

      // prevent old responses from overriding new ones
      if (currentRequestId !== lastRequestId.current) return;

//       console.log("res client list", res);

      if (res?.status === "success") {
        setOwners(res?.data || []);
        set('clientList', res?.data || []);
        setTotalUser1(res?.overall_count);
        setTotalUser(res?.pagination?.total_count);
        setPagecount(res?.pagination?.total_pages);
        setLoading(false)
      } else {
        setOwners([]);
        set('clientList', []);
        setTotalUser1(0);
        setTotalUser(0);
        setPagecount(0);
        setLoading(false)
      }
    } catch (error) {
      if (currentRequestId !== lastRequestId.current) return;
      console.error("Error fetching client list:", error);
      setLoading(false)
      setOwners([]);
    }
  };

  const lastRequestId = useRef(0);

  useEffect(() => {
    sessionStorage.setItem(CLIENT_LIST_PAGE_KEY, String(page || 1));
  }, [page]);

  useEffect(() => {
    // increment request ID for each API call
    const currentRequestId = ++lastRequestId.current;

    let filters = [];
    if (mobile) filters.push(`mobile=${encodeURIComponent(mobile)}`);
    if (formData?.ClientID)
      filters.push(`id=${encodeURIComponent(formData.ClientID)}`);

    getList(page, filters, currentRequestId);
  }, [formData?.ClientID, mobile, page]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  const handleSubmit = () => {
    setMobile(searchData);
  };

  const columns = React.useMemo(
    () => [
      {

        Header: () => (
          <div style={{ textAlign: "center" }}>
            Client <br /> ID
          </div>
        ),
        accessor: "id",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Name",
        accessor: "name",
        Cell: ({ value }) => {
          const truncated =
            value && value.length > 14 ? value.substring(0, 14) + "..." : value;

          return (
            <p style={{ whiteSpace: "nowrap", width: "132px" }}>
              {truncated}
            </p>
          );
        },
      },
      {
        Header: " Mobile No",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: (
          <span>
            Wallet
            <br />
            balance
          </span>
        ),
        accessor: "wallet_amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{`₹${value}`}</p>;
        },
      },

      {
        Header: (
          <span>
            Client
            <br />
            Editor
          </span>
        ),
        accessor: "Editor",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                <button
                  onClick={() => {
                    navigate("/client-report", { state: { type: "edit", data: row.original } });
                  }}
                  className="cust-btn "
                >
                  <img src={edit_icon} alt="" className=" editor-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );


  const maxHeight = useRef(window.visualViewport?.height || window.innerHeight);
  const isFirstRun = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      const visibleHeight = window.visualViewport?.height || window.innerHeight;

      // 🔹 Skip logic on first run
      if (isFirstRun.current) {
        isFirstRun.current = false;
        setBrowsHeader(true);
        return;
      }

      // 🔻 Viewport reduced (keyboard / browser UI)
      if (visibleHeight < maxHeight.current) {
        setBrowsHeader(true);
      }
      // 🔺 Viewport restored
      else {
        maxHeight.current = visibleHeight;
        setBrowsHeader(false);
      }
    };

    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, [browsHeader]);



  return (
    <div style={{
    }} className="dashRightView marginScroll">
      <CustomScroll ref={scrollRef}>
        <div style={{ paddingTop: 0 }} className="container_overalls">
          <div className="form-group col-md-5 text-start my-3">

            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              Mobile Number</label>
            <div className="login-input1 mt-1">
              {/* <div className="clintphone">
              <img style={{ width: 16, height: 10, marginRight: 8 }} src={down} alt="" />
              <span style={{ color: 'white' }}>+91</span>
            </div> */}
              <input
                value={searchData}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 20) {
                    setSearchData(value);
                  }
                }}
                type="tel"
                placeholder="Search mobile number"
                required
                maxLength={20}
                className="placholdercolorchanges2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
              />

              <img src={call} alt="call icon" style={{ marginRight: 12, width: 20, top: 1, position: 'relative' }} />
            </div>
            {errors.mobile && <p className="err">{errors.mobile}</p>}
          </div>
          <div className="col-md-5">
            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              Client ID</label>
            <input
              className="input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 placholdercolorchanges2"
              name="ClientID"
              value={formData.ClientID}
              onChange={handleChange}
              type="number"
              placeholder="Search Client ID"
            />
            {errors.ClientID && <p className="err">{errors.ClientID}</p>}
          </div>

          <div className="col-md-5 my-3">
            <button
              onClick={handleSubmit}
              className="add-button f3  fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white"
            >
              Search
            </button>
          </div>
          <div className="col-md-5 my-3">
            <p className="f2 fs-xs-15 fs-sm-13 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-19">
              Total Users Count: {totalUser1}
            </p>
          </div>

          <Table
            columns={columns}
            setPageno={setPage}
            totalPages={totalUser}
            pagecount={pagecount}
            pageno={page}
            data={owners || []}
            loading={loading}
            show={false}
            serverSide={true}
          />
        </div>
      </CustomScroll>
    </div>
  );
};

export default ClientList;
